var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceSaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5279 22.5278L8.79769 20.7976L9.9955 18.4464L7.35589 19.3558L5.04899 17.0489L8.15443 11.6366L2.7421 14.7421L1.30029 13.3002L9.26553 8.03126C11.3412 6.65819 14.1286 7.15099 15.6077 9.15252C17.1661 11.2614 17.122 14.152 15.4999 16.2123L10.5279 22.5278Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9929 6.67875L19.0104 2.66125C19.7915 1.8802 21.0578 1.8802 21.8388 2.66125C22.6199 3.4423 22.6199 4.70863 21.8388 5.48968L17.8146 9.51392C17.6358 9.17431 17.4296 8.84493 17.1961 8.5289C16.5985 7.72022 15.8384 7.09896 14.9929 6.67875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceSaver);
export default __webpack_public_path__ + "static/media/spaceSaver.4ccb27d58e1b5b908169d33b02e614ee.svg";
export { ForwardRef as ReactComponent };